import fileService from '../services/file.service';

const files = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE

        //READ
        get(_, params) {
            return fileService.get(params.fileId, params.namePrefix);
        },

        //UPDATE

        //DELETE
    },
    getters: {},
    mutations: {},
};

export default files;
